/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';


class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg width="37px" height="38px" viewBox="0 0 37 38" version="1.1" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
    <title>Button</title>
    <g id="Page-1" stroke="none" fill="none" fillRule="evenodd" strokeWidth="1">
        <g id="DisabilityInsurancePage_Desktop-" transform="translate(-1057.000000, -1812.000000)">
            <g id="FAQ_Drawer" transform="translate(322.000000, 1708.775168)">
                <g id="FAQ" transform="translate(0.000000, 76.000000)">
                    <g id="Button" transform="translate(735.500000, 28.000000)">
                        <circle id="Oval" fill="#1570BC" cx="18.144" cy="18.144" r="18.144"/>
                        <g id="Group-2" transform="translate(10.251556, 11.280635)" stroke="#FFFFFF" strokeWidth="3.456" strokeLinecap="square">
                            <line x1="7.9984" y1="0.2592" x2="7.9984" y2="13.7376" id="Line-3"/>
                            <line x1="15.4856571" y1="6.60416216" x2="0.247002353" y2="6.60416216" id="Line-3"/>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>
    );
  }
}

Icon.displayName = 'ButtonPlusIcon';

export default Icon;
